









import { Component, Vue } from 'vue-property-decorator';
import { SidebarModuleMapper } from '@/store/modules/sidebar';
import { MenuModuleMapper } from '@/store/modules/menu';
import { ConstantsModuleMapper } from '@/store/modules/constants';

import SideBarMenu from './sideBarMenu.vue';
import SideBarTop from './sideBarTop.vue';
import SideBarToggle from './sideBarToggle.vue';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['isLoaded', 'sections', 'commonInfo']),
    ...SidebarModuleMapper.mapGetters(['sidebarState']),
    ...MenuModuleMapper.mapGetters(['expandedLvl']),
  },
  methods: {
    ...SidebarModuleMapper.mapMutations({
      toggle: 'toggle',
    }),
  },
});

@Component({
  components: {
    SideBarMenu,
    SideBarTop,
    SideBarToggle,
  },
})
export default class LeftSidebarComponent extends Mappers {
  innerWidth = 0;

  handleResize() {
    this.innerWidth = window.innerWidth;
  }

  mounted() {
    this.handleResize();
  }
}
